import React, { useContext, useEffect, useState } from "react";
import PedidosContext from "../../../../Context/Pedidos/PedidosContext";
import Card from "../Card/Card";
import { Box, Alert, Grid } from "@mui/material";
import OrdersSkeleton from "../OrdersSkeleton";

const PendingPayment = () => {
  const [active, setActive] = useState(-1);
  const [loading, setLoading] = useState(true);
  const handleCollapse = (index) => {
    setActive(active === index ? -1 : index);
  };

  const { orders_client, GetPedidosPendientesDePago } =
    useContext(PedidosContext);

  useEffect(() => {
    setLoading(true);
    const result = GetPedidosPendientesDePago();
    if (result && typeof result.finally === "function") {
      result.finally(() => setLoading(false));
    } else {
      setTimeout(() => setLoading(false), 500);
    }
  }, []);

  if (loading) return <OrdersSkeleton count={3} />;

  return (
    <Box sx={{ mt: 1 }}>
      {orders_client.length > 0 ? (
        <Grid container spacing={2}>
          {orders_client.map((order, index) => (
            <Grid item xs={12} key={index}>
              <Card
                key={index}
                index={index}
                onCollapse={handleCollapse}
                order={order}
                active={active}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Alert
          severity="info"
          sx={{
            mt: 2,
            borderRadius: 2,
            border: "1px solid #E3F2FD",
          }}
        >
          No tienes pedidos pendientes de pago.
        </Alert>
      )}
    </Box>
  );
};

export default PendingPayment;
